// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"jm-z","play":"km-z"};